import { useState } from "react";
import { useServerSdk } from "../../RootNavigator/services/ServerSdk";
import { FinancialOverallSectionDescriptor } from "./utilities";
import { FinancialOverallSectionParams } from "@hpo/client/models/Archive";
import FieldsForm from "@hpo/client/utilities/fields/FieldsForm";
import TextField from "@hpo/client/utilities/fields/TextField";
import { useSubmitCallback } from "@hpo/client/utilities/useSubmitCallback";
import MultiSelectField from "@hpo/client/utilities/fields/MultiSelectField";
import Spacer from "@hpo/client/utilities/Spacer";
import Buttons from "@hpo/client/components/Buttons";
import Button from "@hpo/client/components/Button";
import T from "@hpo/client/components/text/Text";
import Divider from "@hpo/client/components/Divider";
import MessageException from "@hpo/client/utilities/errors/MessageException";
import ErrorToast from "@hpo/client/utilities/ErrorToast";

type FinancialOverallParamsProps = {
  params: Partial<FinancialOverallSectionParams>;
  onChange: (params: FinancialOverallSectionParams) => void;
  onDelete: () => void;
};

export default function FinancialOverallParams(
  props: FinancialOverallParamsProps,
) {
  const { params, onDelete, onChange } = props;
  const server = useServerSdk();
  const allPeriods = server.suspender.use(server.getPeriods_());
  const [title, setTitle] = useState<string | null>(params.title || null);
  const [periods, setPeriods] = useState<Array<string>>(params.periods || []);

  const [onSubmit, submission] = useSubmitCallback(() => {
    if (title === null) throw new MessageException("Titre manquant", null);
    if (periods.length === 0)
      throw new MessageException("Périodes manquantes", null);
    onChange({ type: "financial-overall", title, periods });
  }, [title, periods]);

  return (
    <FieldsForm onSubmit={onSubmit}>
      <ErrorToast error={submission.error} />
      <T style="section">{FinancialOverallSectionDescriptor.title}</T>
      <Spacer />
      <T>{FinancialOverallSectionDescriptor.description}</T>
      <Spacer />
      <Divider />
      <Spacer />
      <TextField
        value={title}
        label="Titre de la section"
        onChange={setTitle}
        required
      />
      <Spacer />
      <MultiSelectField
        value={periods}
        label="Périodes à prendre en compte"
        onChange={setPeriods}
        options={allPeriods}
        keyExtractor={(o) => o}
        renderOption={(o) => ({ label: o })}
        help="Les données de toutes les périodes sélectionnées seront aggrégées. Le détail par période ne sera pas affiché."
        required
      />
      <Spacer />
      <Buttons expand>
        <Button onClick={onDelete} label="Supprimer" style="danger" />
        <Button submit label="Valider" />
      </Buttons>
    </FieldsForm>
  );
}
